import React from 'react'
import moment from 'moment-timezone'
import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'

export const formatDateTime = (
  timeFormats: ITimeFormats,
  start?: string,
  end?: string,
  tz?: string
) => {
  const isBeforeCurrentYear = moment(start).isBefore(moment(), 'year')
  const stopAppointmentFormat = isBeforeCurrentYear
    ? timeFormats?.stopAppointmentFull
    : timeFormats?.stopAppointment
  const startMoment = moment(start)
  const timezone = tz || moment.tz.guess()
  if (!end) {
    return start ? startMoment.tz(timezone).format(`${stopAppointmentFormat} z`) : ''
  }
  const sameDay = startMoment.isSame(end, 'day')
  const startText = startMoment.tz(timezone).format(stopAppointmentFormat)
  const endMoment = moment(end || '')
  if (sameDay) {
    const endText = endMoment.tz(timezone).format(`${timeFormats?.sameDay} z`)
    return `${startText} - ${endText}`
  }
  const endText = endMoment.tz(timezone).format(`${stopAppointmentFormat} z`)
  return (
    <>
      {startText} - <br />
      {endText}
    </>
  )
}
